import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserAuthContext } from '../UserAuthContext';
import LoadingScreen from './LoadingScreen';

const SESSION_LOADING_MESSAGES = [
  'Protecting your account details',
  'Restoring your workspace',
  'Almost ready to continue',
];

const RouteGuard = ({ children }) => {
  const { user, loading } = useContext(UserAuthContext);
  const location = useLocation();

  if (loading) {
    return (
      <LoadingScreen
        eyebrow="SECURE ACCOUNT ACCESS"
        title="Confirming your session"
        messages={SESSION_LOADING_MESSAGES}
      />
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default RouteGuard;
